import React from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { LOAD_START_MARK_KEY } from './common/constants.tsx';
import type ConfigureMailServer from './ui/index.tsx';
import type { ModalProps } from './ui/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncLazyConfigureMailServerModal = lazy<typeof ConfigureMailServer>(
	() => import(/* webpackChunkName: "async-configure-mail-server-modal" */ './ui/index.tsx'),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: ModalProps) => (
	<ErrorBoundary id="configure-mail-server-modal" packageName="jira-configure-mail-server-modal">
		<Placeholder
			name="configure-mail-service-modal"
			fallback={<PerformanceMark metricKey={LOAD_START_MARK_KEY} />}
		>
			{/* @ts-expect-error - TS2741 - Property 'GetIncomingMailServerDetails' is missing in type '{ action: string; id?: string | undefined; name?: string | undefined; authenticationType: AuthenticationType; onClose: () => void; }' but required in type 'DefaultProps'. */}
			<AsyncLazyConfigureMailServerModal {...props} />
		</Placeholder>
	</ErrorBoundary>
);
